export const existUpperCase = (value) => /[A-Z]/.test(value);
export const existLowerCase = (value) => /[a-z]/.test(value);
export const existDigit = (value) => /[0-9]/.test(value);
export const fileValidator = (fileExtensions) => (value) => {
  return Array.isArray(fileExtensions)
    ? fileExtensions.includes(value?.type)
    : fileExtensions === value?.type;
};

export const edrpouFopValidator = (value) => {
  return value.toString().trim().length === 10;
};

export const edrpouTovValidator = (value) => {
  return value.toString().trim().length === 8;
};

export const exactLength = (_exactLength) => (value) => {
  if (!value && _exactLength > 0) {
    return false;
  }

  return value.toString().trim().length === _exactLength;
};
